"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadConfiguration = loadConfiguration;
var _cache = require("./cache");
const CACHE_BACKUP_KEY_SUFFIX = 'Backup';
async function load(cacheKey, cacheBackupKey, loader) {
  const data = await loader();
  _cache.cache.put(cacheKey, data, _cache.TTL.HOUR);
  _cache.cache.put(cacheBackupKey, data, _cache.TTL.DAY);
  return data;
}
async function loadConfiguration(cacheKey, loader, options) {
  if (options?.withoutCache) {
    return loader();
  }
  const CACHE_BACKUP_KEY = (0, _cache.createCacheKey)(cacheKey, CACHE_BACKUP_KEY_SUFFIX);
  let cacheItem = _cache.cache.get(cacheKey);
  if (cacheItem != null) {
    return cacheItem;
  }
  cacheItem = _cache.cache.get(CACHE_BACKUP_KEY);
  if (cacheItem != null) {
    void load(cacheKey, CACHE_BACKUP_KEY, loader);
    return cacheItem;
  }
  return load(cacheKey, CACHE_BACKUP_KEY, loader);
}
//# sourceMappingURL=loadConfiguration.js.map